import {
  CLEAR_TRANSFERRING_REQUEST_CREATED_UPDATED,
  GET_TRANSFERRING_REQUESTS,
  GET_TRANSFERRING_REQUESTS_LIST_FAILURE,
  GET_TRANSFERRING_REQUESTS_LIST_SUCCESS,
  SEND_EXPORT_EXCEL_REQUEST,
  SEND_EXPORT_EXCEL_REQUEST_FAILURE,
  SEND_EXPORT_EXCEL_REQUEST_SUCCESS,
  SET_TRANSFERRING_REQUEST_DETAILS,
} from '../../modules/constants';

export const getTransferringRequestsListRequest = (state, action) => {
  return {
    ...state,
    transferringRequestsListLoading: true,

  };
};
export const getTransferringRequestsListRequestSuccess = (state, action) => {
  const { payload: data } = action;
  if (data.status === 200) {
    return {
      ...state,
      transferringRequestsListLoading: false,
      transferringRequestsList: data.data,
    };
  }
  return {
    ...state,
    transferringRequestsListLoading: false,
    transferringRequestsList: [],
  };
};
export const getTransferringRequestsListRequestFailure = (state, action) => {
  return {
    ...state,
    transferringRequestsListLoading: false,
    transferringRequestsList: [],
  };
};

export const setTransferringRequestDetails = (state, action) => {
  const { payload } = action;
  if (payload && payload.id) {
    return {
      ...state,
      transferringRequestDetails: { ...payload },
    };
  }
  return {
    ...state,
  };
};

export const clearTransferringRequestCreatedUpdated = (state, action) => {
  return {
    ...state,
    transferringRequestDetails: null,
  };
};

export const sendExportExcelRequest = (state, action) => {
  return {
    ...state,
    reportLoading: true,
  };
};

export const sendExportExcelRequestSuccess = (state, action) => {
  return {
    ...state,
    reportLoading: false,
  };
};

export const sendExportExcelRequestFailure = (state, action) => {
  return {
    ...state,
    reportLoading: false,
  };
};




// Action Handlers
const ACTION_HANDLERS = {
  [GET_TRANSFERRING_REQUESTS]: getTransferringRequestsListRequest,
  [GET_TRANSFERRING_REQUESTS_LIST_SUCCESS]:
    getTransferringRequestsListRequestSuccess,
  [GET_TRANSFERRING_REQUESTS_LIST_FAILURE]:
    getTransferringRequestsListRequestFailure,
  [SEND_EXPORT_EXCEL_REQUEST]: sendExportExcelRequest,
  [SEND_EXPORT_EXCEL_REQUEST_SUCCESS]: sendExportExcelRequestSuccess,
  [SEND_EXPORT_EXCEL_REQUEST_FAILURE]: sendExportExcelRequestFailure,
  // [SET_TRANSFERRING_REQUEST_DETAILS]: setTransferringRequestDetails,

  // [CLEAR_TRANSFERRING_REQUEST_CREATED_UPDATED]:
  //   clearTransferringRequestCreatedUpdated,
};


// default initial state
const initialState = {
  transferringRequestsListLoading: false,
  transferringRequestsList: [],
  transferringRequestDetails: null,
  reportLoading: false,
};

export default function transferringRequestsReducer(
  state = initialState,
  action,
) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
